<template>

	<b-container v-if="offer" class="p-0">
		<b-row class="product-details">
			<!-- Product gallery -->
			<b-col cols="12" md="5" class="d-flex align-items-center pt-3">
				<span class="sale-stamp">Sale!</span>
				<ProductGallery :images="offer.media" :title="offer.title"/>
			</b-col>


			<!-- Product information -->
			<b-col cols="12" md="7" class="product-info-column">

				<!-- Name -->
				<h1 class="product-name">{{ offer.title }}</h1>

				<!-- Price -->
				<div class="price">
					<del class="price-original">{{ offer.original_price_local.formatted }}</del>
					<span class="price-discounted">{{ offer.price_local.amount.formatted }}</span>
				</div>

				<!-- Description -->
				<p class="product-description">{{ offer.description }}</p>

				<!-- Buy button -->
				<div class="mt-3 mb-3">
					<a v-if="isInStock" @click="handleBuyClick" href="#option-area">
						<b-button variant="primary" size="lg">BUY NOW</b-button>
					</a>
                    <b-button v-else size="lg" class="product-restock" disabled>OUT OF STOCK</b-button>
				</div>

                <!-- Buy button -->
                <p v-if="restock_date" class="mb-4 product-restock-date">{{ restock_date }}</p>

				<!-- Categories -->
				<div class="categories">
					<span class="text-secondary">Categories:</span>
					<span v-for="(category, index) in offer.categories" :key="index">
						<a :href="`/product-category/${category.slug}`">{{ category.name }}</a>{{ index === offer.categories.length - 1 ? '' : ',' }}
					</span>
				</div>

				<!-- Share links -->
				<div class="product-share">
					<label>Share</label>
					<div class="share-links">
						<!-- Facebook -->
						<a target='_blank' :href='`https://www.facebook.com/sharer/sharer.php?u=${pageURL}&p[title]=${offer.title}`' aria-label="Facebook">
							<i class="fab fa-facebook-f" aria-hidden="true"></i>
						</a>
						<!-- Twitter -->
						<a target='_blank' :href="`https://twitter.com/intent/tweet?text=${offer.title}&url=${pageURL}&hashtags=sculptnation`" aria-label="Twitter">
							<i class="fab fa-twitter" aria-hidden="true"></i>
						</a>
						<!-- Pinterest -->
						<a target='_blank' :href="`https://pinterest.com/pin/create/button/?url=${pageURL}&media=${offer.media[0].url}`" aria-label="Pinterest">
							<i class="fab fa-pinterest-p" aria-hidden="true"></i>
						</a>
						<!-- Email -->
						<a target='_blank' :href="`mailto:?subject=${offer.title}&body=${pageURL}`" aria-label="Email">
							<i class="fas fa-envelope" aria-hidden="true"></i>
						</a>
					</div>
				</div>

			</b-col>

		</b-row>
	</b-container>

</template>

<script>

	import 'scroll-behaviour/polyfill';

	import api from '@js/api';
	import ProductGallery from './ProductGallery.vue';

	export default {
		components: {
			ProductGallery
		},

		props: {
			sku: {
				required: true,
				type: String
			},
            in_stock: {
                type: [Boolean, Number, String],
                default: true
            },
            restock_date: {
                type: String
            }
		},

		data() {
			return {
				offer: null,
				pageURL: window.location.href
			}
		},

		async beforeMount() {
			this.offer = (await api.getOffer(this.sku)).data;
		},

		methods: {
			handleBuyClick(event) {
				event.preventDefault();

				let scrollToElement = document.querySelector('.option-area');

				window.scrollTo({
					top: scrollToElement.getBoundingClientRect().top + window.pageYOffset,
					behavior: 'smooth'
				});
			}
		},

		computed: {
			isInStock() {
				switch (typeof this.in_stock) {
					case "boolean":
						return this.in_stock;
					case "string":
						return this.in_stock === "true";
					case "number":
						return this.in_stock === 1;
				}

				return false;
			}
		}
	}

</script>

<style lang="scss" scoped>

	.product-name {
		font-weight: bold;
		font-size: 1.75rem;
	}

	.product-description {
		font-size: 1rem;
	}

    .product-restock {
        font-size: 1.25rem;
        font-weight: 800;
    }

    .product-restock-date {
        color: #626262;
        font-weight: 700;
    }

	.product-details {
		margin-top: 40px;
		margin-bottom: 40px;
		margin-left: 0.5rem;
		margin-right: 0.5rem;
		padding: 1rem;

		border: 1px solid lightgray;
		border-radius: 8px;
		background-color: white;
	}

	.product-info-column {
		padding: 20px;
	}

	.price {
		margin-bottom: 10px;
	}

	.categories {
		margin-top: 20px
	}

	.product-share {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-top: 20px
	}

	.product-share * {
		display: inline-block;
	}

	.product-share label {
		margin-right: 15px;

		text-transform: uppercase;
		font-weight: 600;
		font-size: 18px;
		line-height: 22px;
		letter-spacing: 0;
		color: #777;
	}

	.share-links i {
		font-size: 14px;
		font-weight: 700;
		text-align: center;
		padding: 8px 0;
		width: 30px;
		height: 30px;
		background-color: #4c4c4c;
		color: #fff;
		border-radius: 100%;
		overflow: hidden;
	}

</style>
